{
  "version": "1.0",
  "builder": "chart",
  "stepperOrientation": "horizontal",
  "linear": false,
  "steps": [
    {
      "id": "chart-type",
      "label": "Chart type",
      "sections": [
        { "id": "chart-type", "fields": [{ "field": "chartTypePicker" }] }
      ]
    },
    {
      "id": "map-fields",
      "label": "Map fields",
      "sections": [
        { "id": "map-fields", "fields": [{ "field": "mapFields" }] }
      ]
    },
    {
      "id": "styling",
      "label": "Formatting & Styling",
      "sections": [
        { "id": "styling", "fields": [{ "field": "styling" }] }
      ]
    },
    {
      "id": "save",
      "label": "Save",
      "sections": [
        { "id": "save", "fields": [{ "field": "save" }] }
      ]
    }
  ],

  "options": {
    "aggregations": [
      { "label": "Sum", "value": "sum" },
      { "label": "Average", "value": "avg" },
      { "label": "Count", "value": "count" },
      { "label": "Distinct Count", "value": "distinctCount" },
      { "label": "Minimum", "value": "min" },
      { "label": "Maximum", "value": "max" },
      { "label": "Median", "value": "median" },
      { "label": "Range (max - min)", "value": "range" },
      { "label": "First", "value": "first" },
      { "label": "Last", "value": "last" }
    ],
    "palettes": [
      { "key": "default", "label": "Default", "colors": ["#1f6feb", "#0f9f8f", "#8657d6", "#f59e0b", "#ef4444", "#10b981", "#3b82f6", "#ec4899"] },
      { "key": "warm", "label": "Warm", "colors": ["#ef4444", "#f97316", "#f59e0b", "#eab308", "#dc2626", "#b45309", "#9333ea", "#c026d3"] },
      { "key": "cool", "label": "Cool", "colors": ["#0ea5e9", "#06b6d4", "#0891b2", "#0284c7", "#2563eb", "#1d4ed8", "#4f46e5", "#7c3aed"] },
      { "key": "vibrant", "label": "Vibrant", "colors": ["#ec4899", "#06b6d4", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#0ea5e9", "#84cc16"] },
      { "key": "monochrome", "label": "Monochrome", "colors": ["#1e293b", "#334155", "#475569", "#64748b", "#94a3b8", "#cbd5e1", "#0f172a", "#020617"] }
    ],
    "sortDirections": [
      { "label": "Ascending", "value": "asc" },
      { "label": "Descending", "value": "desc" }
    ],
    "topNDirections": [
      { "label": "Top", "value": "top" },
      { "label": "Bottom", "value": "bottom" }
    ],
    "dateGranularities": [
      { "label": "None", "value": "none" },
      { "label": "Day", "value": "day" },
      { "label": "Week", "value": "week" },
      { "label": "Month", "value": "month" },
      { "label": "Quarter", "value": "quarter" },
      { "label": "Year", "value": "year" }
    ],
    "numberFormats": [
      { "value": "plain", "label": "Plain (1234)" },
      { "value": "thousands", "label": "Thousands (1,234)" },
      { "value": "percent", "label": "Percent (12%)" },
      { "value": "currency", "label": "Currency ($1,234)" }
    ],
    "legendPositions": [
      { "value": "top", "label": "Top" },
      { "value": "bottom", "label": "Bottom" },
      { "value": "left", "label": "Left" },
      { "value": "right", "label": "Right" }
    ],
    "labelModes": [
      { "value": "value", "label": "Value" },
      { "value": "percent", "label": "Percent" },
      { "value": "name-value", "label": "Name + Value" },
      { "value": "name-percent", "label": "Name + Percent" }
    ],
    "tooltipTriggers": [
      { "value": "auto", "label": "Auto (per chart type)" },
      { "value": "axis", "label": "Axis (whole category)" },
      { "value": "item", "label": "Item (single point/slice)" }
    ],
    "axisPointerStyles": [
      { "value": "none", "label": "None" },
      { "value": "line", "label": "Vertical line" },
      { "value": "cross", "label": "Crosshair" },
      { "value": "shadow", "label": "Shadow band" }
    ],
    "entityGroup": "NontimeSeriesEntities",
    "hiddenColumns": ["uuid", "__rowKey", "source_row_hash", "sourced_row_hash", "spriced_row_hash"],
    "tooltipPresets": [
      { "key": "dark", "label": "Dark", "background": "#1e293b", "textColor": "#f8fafc", "borderColor": "#334155" },
      { "key": "light", "label": "Light", "background": "#ffffff", "textColor": "#0f172a", "borderColor": "#cbd5e1" },
      { "key": "navy", "label": "Navy", "background": "#0f172a", "textColor": "#e0f2fe", "borderColor": "#1e3a8a" },
      { "key": "amber", "label": "Amber", "background": "#fff7ed", "textColor": "#7c2d12", "borderColor": "#fdba74" },
      { "key": "emerald", "label": "Emerald", "background": "#064e3b", "textColor": "#ecfdf5", "borderColor": "#10b981" }
    ]
  },

  "defaults": {
    "aggregation": "sum",
    "style": {
      "legendPosition": "bottom",
      "palette": "default",
      "numberFormat": "plain",
      "decimals": 0,
      "tableRowLimit": 50,
      "tooltipBackground": "#1e293b",
      "tooltipTextColor": "#f8fafc",
      "tooltipBorderColor": "#334155",
      "tooltipBorderRadius": 6,
      "tooltipFontSize": 12,
      "tooltipAxisPointer": "line"
    }
  },

  "apiEndpoints": {
    "entityApi":"/getAllEntities/NontimeSeriesEntities",
    "entityDataApi":"/cols_quote_summary/dynamic_filter",
    "baseUrl": "",
    "uploadUrl": "",
    "chatUrl": "/ppt-dashboard/generate"
  }
}

